import request from 'superagent'
import { AuthenticationDetails, CognitoUserPool, CognitoUser, CognitoUserAttribute } from 'amazon-cognito-identity-js'
import Config from '../Config'

const AWSAPI = {
  getUserPool (userRole) {
    const userPoolData = Config.cognitoSetting
    let userPool = new CognitoUserPool(userPoolData[userRole])
    return userPool
  },
  getUserRoleUrlFromUserRole (userRole) {
    switch (userRole) {
      case 'admin':
        return 'admin'
      case 'companyAdmin':
        return 'company_admin'
      case 'companyUser':
        return 'company_user'
      default:
        break
    }
  },
  getCognitoUser (username, userPool) {
    let cognitoUserData = {
      Username: username,
      Pool: userPool
    }
    let cognitoUser = new CognitoUser(cognitoUserData)
    return cognitoUser
  },
  getAuthenticationDetails (username, password) {
    let authenticationData = {
      Username: username,
      Password: password
    }
    let authenticationDetails = new AuthenticationDetails(authenticationData)
    return authenticationDetails
  },
  isLoggedIn (userRole) {
    const userPool = AWSAPI.getUserPool(userRole)
    const cognitoUser = userPool.getCurrentUser()
    return (cognitoUser != null)
  },
  authenticateUser(userRole, username, password, onSuccess, onFailure, newPasswordRequired, onSuccessToChangeTemporaryPassword) {
      const userPool = AWSAPI.getUserPool(userRole)
      const cognitoUser = AWSAPI.getCognitoUser(username, userPool)
      const authenticationDetails = AWSAPI.getAuthenticationDetails(username, password)
      cognitoUser.authenticateUser(authenticationDetails, {
          onSuccess: (session) => {
            cognitoUser.getUserAttributes((err, attributes) => {
              if (err) {
                console.error('Failed to get user attributes:', err)
                onFailure(new Error('Failed to retrieve user attributes.'))
                return
              }
              const approvalFlgAttr = attributes.find(attr => attr.Name === 'custom:approvalFlg')
              const approvalFlg = !approvalFlgAttr || approvalFlgAttr.Value === 'true'
              if (approvalFlg === false) {
                console.error('Approval Flag is false. Login denied.')
                cognitoUser.signOut()
                onFailure(new Error('Approval Flag is false. Login denied.'))
                return
              }
              onSuccess(session)
            })
          },
          onFailure: (err) => {
            console.error('Authentication failed:', err)
            onFailure(err)
          },
          newPasswordRequired: (userAttributes, requiredAttributes) => {
            newPasswordRequired(userAttributes, requiredAttributes, cognitoUser, onSuccessToChangeTemporaryPassword, onFailure)
          }
      });
  },
  writeActionLog (userRole, apiUrl, actionName, onSuccess) {
    const params = {
      command: 'set',
      actionName: actionName
    }
    AWSAPI.apiPost(userRole, apiUrl, params, onSuccess)
  },
  forgotPassword (userRole, username, onSuccess, onFailure, inputVerificationCode) {
    const userPool = AWSAPI.getUserPool(userRole)
    const cognitoUser = AWSAPI.getCognitoUser(username, userPool)
    cognitoUser.forgotPassword({
      onSuccess: onSuccess,
      onFailure: onFailure,
      inputVerificationCode: () => {
        inputVerificationCode(cognitoUser, onSuccess, onFailure)
      }
    })
  },
  confirmPassword (userRole, username, verificationCode, newPassword, onSuccess, onFailure) {
    const userPool = AWSAPI.getUserPool(userRole)
    const cognitoUser = AWSAPI.getCognitoUser(username, userPool)
    cognitoUser.confirmPassword(verificationCode, newPassword, {
      onSuccess: onSuccess,
      onFailure: onFailure
    })
  },
  logout (userRole) {
    const userPool = AWSAPI.getUserPool(userRole)
    const cognitoUser = userPool.getCurrentUser()
    if (cognitoUser != null) {
      cognitoUser.getSession((err, session) => {
        if (err) {
          // console.log(err)  //デバッグ時以外はコメントアウト
        }
      })
    }
    cognitoUser.signOut()
  },
  changePassword (userRole, oldPassword, newPassword, onSuccess, onFailure) {
    const userPool = AWSAPI.getUserPool(userRole)
    const cognitoUser = userPool.getCurrentUser()
    if (cognitoUser != null) {
      cognitoUser.getSession((err, session) => {
        if (err) {
          console.log(err)
        }
        // console.log('session validity: ' + session.isValid())
      })
    }
    cognitoUser.changePassword(oldPassword, newPassword, (err, result) => {
      if (err) {
        if (onFailure) onFailure(err)
        return
      }
      if (onSuccess) onSuccess(result)
    })
  },
  getUserAttributes (userRole, callback) {
    const userPool = AWSAPI.getUserPool(userRole)
    const cognitoUser = userPool.getCurrentUser()
    if (cognitoUser != null) {
      cognitoUser.getSession((err, session) => {
        if (err) {
          // console.log(err)  //デバッグ時以外はコメントアウト
        }
      })
    }
    cognitoUser.getUserAttributes((err, data) => {
    // console.log(data)
      if (err) {
        if ('localStorage' in window) {
          window.localStorage.clear()
        }
        if ('sessionStorage' in window) {
          window.sessionStorage.clear()
        }
        window.location.href = '/' + this.getUserRoleUrlFromUserRole(userRole) + '/login'
        return false
      }
      callback(null, data)
    })
  },
  updateAttributes (userRole, attributeList, callback) {
    const userPool = AWSAPI.getUserPool(userRole)
    const cognitoUser = userPool.getCurrentUser()
    if (cognitoUser != null) {
      cognitoUser.getSession((err, session) => {
        if (err) {
          // console.log(err)  //デバッグ時以外はコメントアウト
        }
      })
    }
    let congnitoUserAttributeList = attributeList.map((e) => {
      return new CognitoUserAttribute(e)
    })
    cognitoUser.updateAttributes(congnitoUserAttributeList, callback)
  },
  getCurrentUserId (userRole) {
    const userPool = AWSAPI.getUserPool(userRole)
    const cognitoUser = userPool.getCurrentUser()
    if (cognitoUser != null) {
      cognitoUser.getSession((err, session) => {
        if (err) {
          // console.log(err)  //デバッグ時以外はコメントアウト
        }
      })
    }
    return cognitoUser.username
  },
  callAPI (userRole, api) {
    const userPool = AWSAPI.getUserPool(userRole)
    const cognitoUser = userPool.getCurrentUser()
    if (cognitoUser != null) {
      cognitoUser.getSession((err, session) => {
        if (err) {
          // console.log(err)  //デバッグ時以外はコメントアウト
          return
        }
        const token = session.getIdToken().getJwtToken()
        const isSessionValid = session.isValid()
        api(isSessionValid, token)
      })
    }
  },
  apiPost (userRole, url, params, onSuccess, onFailure) {
    AWSAPI.callAPI(userRole, (isSessionValid, token) => {
      request.post(url)
      .set({
        'Authorization': token
      })
      .send(params)
      .end((err, res) => {
        if (err) {
          if (onFailure) onFailure(res)
          // console.log('API:POST実行エラー', err.stack)  // デバッグ時以外はコメントアウト
          return
        }
        // console.log(res.body) // 成功時: デバッグ以外ではオフ
        if (onSuccess) onSuccess(res)
        return res
      })
    })
  },
  apiPostNoLogin (url, params, onSuccess, onFailure) {
    request.post(url)
    .send(params)
    .end((err, res) => {
      if (err) {
        if (onFailure) onFailure(res)
        // console.log('API:POST実行エラー', err.stack)  // デバッグ時以外はコメントアウト
        return
      }
      // console.log(res.body) // 成功時: デバッグ以外ではオフ
      if (onSuccess) onSuccess(res)
      return res
    })
  }
}
export default AWSAPI



// WEBPACK FOOTER //
// ./src/common/AWSAPI.js